{
  "addSensor": "Aggiungi sensore",
  "linearMovePathTitle": "Percorso di spostamento lineare",
  "centerPivotPathTitle": "Schema del perno centrale",
  "addSensorAlreadyAddedWithSensorNameErrorMessage": "Questo dispositivo ha già un sensore {{sensorName}} configurato. Contatta il supporto FarmHQ se hai bisogno di assistenza.",
  "addSensorCannotAddToExistingErrorMessage": "Questo sensore non può essere aggiunto a una configurazione esistente. Contatta il supporto FarmHQ se hai bisogno di assistenza.",
  "addSensorInstructions": "Seleziona un sensore da aggiungere alla configurazione del tuo dispositivo.",
  "addSensorNotCompatibleErrorMessage": "Questo sensore non è compatibile con la configurazione del dispositivo. Contatta il supporto FarmHQ se hai bisogno di assistenza.",
  "addSensorTitleWithSensorName": "Aggiungi la configurazione del sensore {{sensorName}}",
  "chooseInstallationType": "Scegli il tipo di installazione",
  "choosePressureSensorModelInstructions": "Seleziona il modello del sensore di pressione installato sul tuo dispositivo.",
  "choosePumpTypeInstructions": "Scegli l'opzione che meglio descrive la tua attrezzatura e la tua installazione.",
  "choosePumpTypeTitle": "Seleziona il tipo di pompa",
  "choosePumpType_pump_off_only": {
    "description": "Pompa solo spegnimento (diesel, arresto di emergenza elettrico)",
    "label": "Pompa solo off"
  },
  "choosePumpType_pump_on_off": {
    "description": "Contatto singolo On/Off (fase 4 Diesel, elettrico)",
    "label": "Pompa On/Off"
  },
  "choosePumpType_pump_vfd": {
    "description": "Pompa VFD con controllo della velocità",
    "label": "Pompa VFD"
  },
  "chooseSensorPortInstructionsWithSensorName": "Seleziona la porta del sensore in cui è installato il sensore {{sensorName}}.\n\nNota che porte del sensore non abbinate correttamente impediranno al dispositivo di produrre letture corrette. In caso di dubbi, contatta l'assistenza FarmHQ.",
  "chooseSensorPortStageTitle": "Seleziona la porta del sensore",
  "clickSensorToManage": "Fare clic su un sensore per visualizzarne o gestirne la configurazione.",
  "clickSensorToManageMobile": "Tocca un sensore per visualizzarne o gestirne la configurazione.",
  "configurationInfoTitle": "Informazioni di configurazione",
  "configurationRequiredMessage": "Prima di eseguire questa azione, è necessario immettere le informazioni di configurazione per questo dispositivo.",
  "configurationRequiredTitle": "Configurazione richiesta",
  "configuredSensors": "Sensori configurati",
  "confirm": "Confermare",
  "customizeDeviceNameInstructions": "Puoi dare un soprannome al tuo dispositivo per aiutarti a identificarlo. Questo nome verrà visualizzato nell'app FarmHQ. Se lasci vuoto questo campo, il dispositivo verrà chiamato con il suo alias di prodotto.",
  "customizeDeviceNameStageTitle": "Personalizza il nome del dispositivo",
  "deleteSensor": "Elimina sensore",
  "deleteSensorImpactFunctionalityWarning": "Ciò potrebbe avere un impatto negativo sulla funzionalità del tuo dispositivo.\n\nSe non sei sicuro di cosa stai facendo, contatta l'assistenza FarmHQ.",
  "deleteSensorSensorIsRequiredMessage": "Questo sensore è necessario per il funzionamento del tuo dispositivo e non può essere eliminato. Se hai bisogno di supporto, contatta FarmHQ.",
  "deleteSensorTitleWithSensorName": "Conferma Elimina Configurazione {{sensorName}}",
  "deviceInstallationType": "Tipo di installazione",
  "deviceName": "Nome dispositivo",
  "deviceNameInputLabel": "Nome dispositivo",
  "deviceNameInputPlaceholder": "Inserisci un nome per questo dispositivo",
  "deviceSetup": "Configurazione del dispositivo",
  "doesItHaveAFlowSensor": "Il dispositivo è dotato di un sensore di flusso installato?",
  "doesItHaveAPressureSensor": "Il dispositivo ha un sensore di pressione installato?",
  "edit": "Modificare",
  "editSensorField": "Modifica campo sensore",
  "forbidden": "Vietato",
  "hardwareGeneration": "Generazione hardware",
  "helpContentBodyText": "Le configurazioni del dispositivo vengono utilizzate per impostare il dispositivo con i sensori e le impostazioni corretti. Ciò garantisce che il dispositivo possa tracciare e segnalare dati in modo accurato e possa essere utilizzato in automazioni e notifiche.",
  "hintWithColon": "Suggerimento:",
  "hose": "Tubo flessibile",
  "linkTo": "Configurazione",
  "manageSensor": "Gestisci sensore",
  "manageSensorWithSensorName": "Gestisci il sensore {{sensorName}}",
  "newConfiguration": "Nuova configurazione",
  "newDeviceConfiguration": "Nuova configurazione del dispositivo",
  "newReelConfiguration": "Nuova configurazione della bobina",
  "noConfiguredSensorsMessage": "Nessun sensore configurato per questo dispositivo.",
  "notNow": "Non adesso",
  "nozzle": "Ugello",
  "pathConfigurationLinearTitle": "Configurazione del percorso lineare",
  "pathConfigurationPivotTitle": "Configurazione del perno",
  "pc1PumpSetupStageTitle": "Configurazione della pompa PC1 (legacy)",
  "pressureSensor": "Sensore di pressione",
  "pressureSensorModelNameMeas": "MISURA",
  "pressureSensorModelNameOther": "Altro",
  "pressureSensorModelNameSoway": "Soway",
  "pressureSensorModelNameTrafag": "Trafiggere",
  "pressureSensorModelStageTitle": "Scegli il modello del sensore di pressione",
  "pressureThresholdsHelpText": "Le soglie di pressione aiutano a determinare quando un dispositivo dotato di centro di pressione sta pompando più o meno acqua del previsto.",
  "pressureThresholdsStageTitle": "Soglie di pressione",
  "pumpType": "Tipo di pompa:",
  "removeFromFarmAreYouSure": "Vuoi davvero rimuovere questo dispositivo da questo account aziendale?",
  "removeFromFarmLinkTo": "Rimuovi dall'azienda",
  "removeFromFarmTitle": "Conferma rimozione dispositivo",
  "removeFromFarmWarning": "Il dispositivo verrà ripristinato alle impostazioni di fabbrica e non apparirà più in questo account. Questa operazione non può essere annullata.",
  "rename": "Rinominare",
  "renameDevice": "Rinomina dispositivo",
  "renameThisDevice": "Rinomina questo dispositivo",
  "resetDeviceAreYouSure": "Vuoi davvero ripristinare le impostazioni predefinite di questo dispositivo?",
  "resetDeviceLinkTo": "Ripristino delle impostazioni di fabbrica",
  "resetDeviceTitle": "Conferma ripristino dispositivo",
  "resetDeviceYouWillLoseConfigurations": "Perderai tutte le configurazioni dei sensori e tutte le altre personalizzazioni. Questo non può essere annullato.",
  "resetDeviceYouWillLoseTriggers": "Verranno eliminate anche tutte le coppie di dispositivi, le notifiche e le automazioni.",
  "reviewAndSubmitInstructions": "Il tuo dispositivo verrà configurato con le seguenti impostazioni. Rivedile e invia per salvare le modifiche.",
  "selectPressureSensorToContinue": "Seleziona un modello di sensore di pressione per continuare. Se non sei sicuro, contatta l'assistenza FarmHQ.",
  "sensorPortHint": "Assicurati che la porta del sensore sia identificata correttamente. Le porte del sensore commutate possono portare a letture errate.",
  "sensors": "Sensori",
  "setPressureThresholdInstructions": "Imposta le soglie di pressione per determinare quando la tua attrezzatura pompa più o meno acqua del previsto.",
  "setUp": "Imposta dispositivo",
  "setUpCenterPivot": "Configurazione del perno centrale",
  "setUpDevice": "Imposta dispositivo",
  "setUpLinearMove": "Impostazione del movimento lineare",
  "setUpPump": "Configurazione della pompa",
  "setUpReel": "Impostazione della bobina",
  "setUpReelDescription": "Inserisci le informazioni di calibrazione del tuo mulinello per garantire un monitoraggio accurato dell'irrigazione, dell'ETA e di altre metriche.",
  "setUpSoftHoseTraveler": "Configurazione del viaggiatore Soft-Hose",
  "setUpTravelerSoft": "Configurazione del viaggiatore Soft-Hose",
  "setUpValve": "Impostazione della valvola",
  "spool": "Bobina",
  "thisDeviceAlreadyHasThatSensorWithSensorName": "Questo dispositivo aveva già una configurazione {{sensorName}} attiva. Per modificarla o eliminarla, selezionala dall'elenco.",
  "title": "Configurazione",
  "unconfiguredDeviceWarning": "Questo dispositivo non è configurato.",
  "updateConfigurationDataLossWarning": "Durante la sincronizzazione delle modifiche, il dispositivo potrebbe anche subire una temporanea perdita di dati.",
  "updateConfigurationSwitchOnToOffWarning": "L'aggiornamento della configurazione del dispositivo causerà lo spegnimento dell'interruttore, se è acceso.",
  "vfdTrackingSpeedsStageTitle": "Velocità di tracciamento VFD",
  "wheelDiameterMmInstructions": "Misura il diametro della ruota e inseriscilo qui.",
  "wheelDiameterStageTitle": "Diametro della ruota",
  "wheelMagnetsStageTitle": "Magneti per ruote",
  "wheelNMagnetsInstructions": "Inserisci il numero di magneti installati sulla ruota.",
  "wheelSensorPortInstructions": "Dove è installato il sensore della ruota?",
  "wheelSensorPortStageTitle": "Porta sensore ruota",
  "wheelStoppedTimeoutInstructions": "Quanto tempo il dispositivo deve attendere senza rilevare il movimento della ruota prima di segnalare la ruota come ferma.",
  "wheelStoppedTimeoutStageTitle": "Timeout ruota ferma",
  "wouldYouLikeToSetLinearPath": "Vuoi impostare ora il percorso lineare?"
}
